/**
 * K2B: Shop / SNS など正規ログイン以外の入口を無効化
 *
 * 触らないもの:
 * - メール＋パスワードの customer_login / recover
 * - ログイン後の /account・カート・Draft Order 購入
 * - Shop Pay 決済ボタン（payment）自体
 *
 * 塞ぐもの:
 * - Login with Shop（data-login-with-shop-* / shop-login-button）
 * - Shop ログイン OAuth への誘導クリック
 */
(function () {
  var OBSERVE_MS = 20000;
  var ATTRS = ['data-login-with-shop-sign-in', 'data-login-with-shop-sign-up'];
  var HIDE_SELECTORS = [
    'shop-login-button',
    'shop-login',
    '[data-shop-login-button]',
    '.shop-login-button',
    'button[name="login_with_shop"]',
    'a[href*="/services/login_with_shop"]',
    'a[href*="login_with_shop"]',
  ].join(',');

  function isPaymentContext(el) {
    if (!el || !el.closest) return false;
    return Boolean(
      el.closest(
        'shop-pay-button, .shopify-payment-button, [data-shopify-pay], .shopify-cleanslate',
      ),
    );
  }

  function stripAttrs(root) {
    var scope = root && root.querySelectorAll ? root : document;
    ATTRS.forEach(function (attr) {
      scope.querySelectorAll('form[' + attr + ']').forEach(function (form) {
        form.removeAttribute(attr);
      });
    });
  }

  function hideAltLoginUi(root) {
    var scope = root && root.querySelectorAll ? root : document;
    try {
      scope.querySelectorAll(HIDE_SELECTORS).forEach(function (el) {
        if (isPaymentContext(el)) return;
        el.setAttribute('data-ktob-alt-login-hidden', '1');
        el.setAttribute('aria-hidden', 'true');
        el.setAttribute('hidden', '');
        el.style.setProperty('display', 'none', 'important');
        el.style.setProperty('pointer-events', 'none', 'important');
      });
    } catch (_e) {}
  }

  function neutralize(root) {
    stripAttrs(root);
    hideAltLoginUi(root);
  }

  function looksLikeShopLoginHref(href) {
    if (!href) return false;
    var h = String(href).toLowerCase();
    if (h.indexOf('login_with_shop') !== -1) return true;
    if (h.indexOf('/services/login_with_shop') !== -1) return true;
    if (h.indexOf('pay.shopify.com/pay/sdk-authorize') !== -1 && h.indexOf('loginwithshop') !== -1) {
      return true;
    }
    return false;
  }

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!target || !target.closest) return;
      if (isPaymentContext(target)) return;

      var shopBtn = target.closest(
        'shop-login-button, shop-login, [data-shop-login-button], .shop-login-button, button[name="login_with_shop"]',
      );
      if (shopBtn) {
        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
        neutralize();
        return;
      }

      var link = target.closest('a[href]');
      if (link && looksLikeShopLoginHref(link.getAttribute('href'))) {
        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
      }
    },
    true,
  );

  document.addEventListener(
    'focusin',
    function (event) {
      var input = event.target;
      if (!input || input.tagName !== 'INPUT') return;
      var form = input.form || (input.closest && input.closest('form'));
      if (!form) return;
      var isLoginForm =
        form.getAttribute('data-login-with-shop-sign-in') != null ||
        form.getAttribute('data-login-with-shop-sign-up') != null ||
        form.id === 'customer_login' ||
        (form.getAttribute('action') || '').indexOf('/account/login') !== -1;
      if (!isLoginForm) return;
      stripAttrs(form.parentNode || document);
      hideAltLoginUi(document);
    },
    true,
  );

  neutralize();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      neutralize();
    });
  }

  window.addEventListener('load', function () {
    neutralize();
  });

  try {
    var obs = new MutationObserver(function (mutations) {
      var needs = false;
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type === 'attributes' && ATTRS.indexOf(m.attributeName) !== -1) {
          needs = true;
          break;
        }
        if (m.addedNodes && m.addedNodes.length) {
          needs = true;
          break;
        }
      }
      if (needs) neutralize();
    });
    obs.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ATTRS,
    });
    window.setTimeout(function () {
      try {
        obs.disconnect();
      } catch (_e) {}
      neutralize();
    }, OBSERVE_MS);
  } catch (_e) {}

  window.ktobDisableAltLogin = { neutralize: neutralize, stripAttrs: stripAttrs };
})();
